module.exports = __webpack_public_path__ + "img/BG_Kopilote_Mobile.66e7da74.svg";